import styled from 'styled-components'
import { Panel } from 'ui/components/Panel'

const PageWrapper = styled.div`
  @media print {
    display: none;
    height: 100vh;
  }
`

const TablePanel = styled(Panel)`
  margin-bottom: 70px;
`

export const s = { PageWrapper, TablePanel }
